import { render, staticRenderFns } from "./G_KAIGAI_ActionsBtn.vue?vue&type=template&id=6ad728e6&scoped=true&"
import script from "./G_KAIGAI_ActionsBtn.vue?vue&type=script&lang=ts&"
export * from "./G_KAIGAI_ActionsBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad728e6",
  null
  
)

export default component.exports